module.exports = __webpack_public_path__ + "static/media/about.9511c86a.md";